import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { IInitialState } from '../../../../../reduxService';
import { useAppSelector } from '../../../../../reduxService/hooks';
import { IProjectMacra1 } from '../../../../MACRA_1/store/project/projectSlice';
import { IProjectMacra2 } from '../../../../MACRA_2/store/project/projectSlice';
import { getActionByProjectType } from '../../../../actionMap';
import { endpoint } from '../../../../pages';
import { selectProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import { EErrorBreadcrumb, getErrorBreadcrumb } from '../../../../utils/utils';
import './Breadcrumb.scss';
import { IBreadcrumbProps } from './IBreadcrumb';

const Breadcrumb = (props: IBreadcrumbProps) => {
    const { t } = useTranslation();
    const projectInfo = useAppSelector(selectProjectInfo);

    const { selectProject } = getActionByProjectType();

    const project: IInitialState<IProjectMacra1 | IProjectMacra2> = useAppSelector(selectProject as any);
    const location = useLocation();

    const error = getErrorBreadcrumb();

    const breadcrumbObj = {
        [endpoint.projectInfo]: t('breadcrumb_project_info'),
        [endpoint.projectType]: t('breadcrumb_project_type'),
        [endpoint.template]: t('breadcrumb_template'),
        [endpoint.designCondition]: t('breadcrumb_design_condition'),
    };

    return (
        <div className='breadcrumb-container d-flex justify-content-between'>
            <ul className='breadcrumb' aria-label='breadcrumb'>
                {!location.pathname.includes('backoffice') &&
                    Object.keys(breadcrumbObj).map(x => {
                        let isActive = location.pathname.includes(x);
                        let slice = x == endpoint.projectInfo || x == endpoint.projectType ? projectInfo : project;
                        return (
                            <li className={!!isActive ? 'active' : 'disactive'} key={breadcrumbObj[x]}>
                                <Link className={slice.initialState ? 'pointer-events-none' : ''} to={x}>
                                    {breadcrumbObj[x]}
                                </Link>
                            </li>
                        );
                    })}
            </ul>
            {error.type !== EErrorBreadcrumb.None && (
                <Alert variant='filled' severity='error'>
                    {error.errorMessage}
                </Alert>
            )}
        </div>
    );
};

export default Breadcrumb;
